var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimaryText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.00003V1.00003C22 0.450031 21.55 3.05176e-05 21 3.05176e-05H17C16.45 3.05176e-05 16 0.450031 16 1.00003V2.00003H6V1.00003C6 0.450031 5.55 3.05176e-05 5 3.05176e-05H1C0.45 3.05176e-05 0 0.450031 0 1.00003V5.00003C0 5.55003 0.45 6.00003 1 6.00003H2V16H1C0.45 16 0 16.45 0 17V21C0 21.55 0.45 22 1 22H5C5.55 22 6 21.55 6 21V20H16V21C16 21.55 16.45 22 17 22H21C21.55 22 22 21.55 22 21V17C22 16.45 21.55 16 21 16H20V6.00003H21C21.55 6.00003 22 5.55003 22 5.00003ZM2 2.00003H4V4.00003H2V2.00003ZM4 20H2V18H4V20ZM16 18H6V17C6 16.45 5.55 16 5 16H4V6.00003H5C5.55 6.00003 6 5.55003 6 5.00003V4.00003H16V5.00003C16 5.55003 16.45 6.00003 17 6.00003H18V16H17C16.45 16 16 16.45 16 17V18ZM20 20H18V18H20V20ZM18 4.00003V2.00003H20V4.00003H18ZM11.94 6.65003C11.79 6.26003 11.41 6.00003 10.99 6.00003C10.57 6.00003 10.19 6.26003 10.05 6.65003L7.28 13.98C7.09 14.47 7.45 15 7.98 15C8.3 15 8.58 14.8 8.69 14.5L9.24 13H12.73L13.29 14.51C13.4 14.8 13.68 15 14 15H14.01C14.54 15 14.9 14.47 14.72 13.98L11.94 6.65003V6.65003ZM9.69 11.74L11 7.91003L12.3 11.74H9.69Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryText);
export default __webpack_public_path__ + "static/media/PrimaryText.654294f0.svg";
export { ForwardRef as ReactComponent };